import { z } from "zod";
import { bookProductionProductSchema } from "./book-production-evidence.js";
const id = z.string().min(1).max(240);
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
const points = z.object({ width: z.number().positive(), height: z.number().positive() }).strict();
export const customerBookProductFactsV1Schema = z
    .object({
    contract: z.literal("LC_CUSTOMER_BOOK_PRODUCT_FACTS_V1"),
    identity: z
        .object({
        bookId: id,
        family: z.enum(["BEDTIME", "MY_STORY", "OUR_STORY", "COOKBOOK", "COMIC"]),
        sourceRevision: z.number().int().nonnegative().nullable(),
        packageId: id.nullable(),
        planDigestSha256: digest.nullable(),
        profileId: id.nullable(),
        profileVersion: id.nullable(),
        entitlementId: id.nullable(),
        offerId: id.nullable(),
    })
        .strict(),
    currentness: z
        .object({
        state: z.enum(["CURRENT", "STALE", "UNKNOWN"]),
        reasonCode: z.enum([
            "CURRENT_EXACT_BINDING",
            "APPROVED_PACKAGE_UNAVAILABLE",
            "BOOK_SOURCE_CHANGED",
            "BOOK_FAMILY_PACKAGE_MISMATCH",
            "PACKAGE_POINTER_CHANGED",
        ]),
    })
        .strict(),
    observedPdf: z
        .object({
        state: z.enum(["OBSERVED_APPROVED_BYTES", "UNKNOWN"]),
        reasonCode: z.enum(["CURRENT_APPROVED_PACKAGE", "APPROVED_PACKAGE_UNAVAILABLE"]),
        product: bookProductionProductSchema.nullable(),
        interiorPageCount: z.number().int().positive().nullable(),
        coverPageCount: z.number().int().positive().nullable(),
        interiorMediaBoxPoints: points.nullable(),
        coverMediaBoxPoints: points.nullable(),
        interiorChecksumSha256: digest.nullable(),
        coverChecksumSha256: digest.nullable(),
    })
        .strict(),
    physicalProduct: z
        .object({
        state: z.enum(["VERIFIED", "RELEASE_GATED", "UNKNOWN"]),
        reasonCode: z.enum([
            "ACTIVE_EXACT_PROFILE",
            "PROFILE_ACTIVATION_BLOCKED",
            "PROFILE_IDENTITY_STALE",
            "APPROVED_PACKAGE_UNAVAILABLE",
            "BOOK_FAMILY_PACKAGE_MISMATCH",
        ]),
        provider: z.literal("GELATO").nullable(),
        providerEnvironment: z.literal("PRODUCTION").nullable(),
        providerProductUid: id.nullable(),
        trim: z
            .object({
            state: z.enum(["VERIFIED_EXACT_TEMPLATE", "SESSION_RECORDED_NOT_ARCHIVED", "UNKNOWN"]),
            widthMm: z.number().positive().nullable(),
            heightMm: z.number().positive().nullable(),
        })
            .strict(),
        binding: z
            .object({
            state: z.literal("UNKNOWN"),
            value: z.null(),
            reasonCode: z.literal("NOT_SEPARATELY_RECORDED"),
        })
            .strict(),
        finish: z
            .object({
            state: z.literal("UNKNOWN"),
            value: z.null(),
            reasonCode: z.literal("NOT_SEPARATELY_RECORDED"),
        })
            .strict(),
        activationBlockers: z.array(id).max(50),
    })
        .strict(),
    includedCopy: z
        .object({
        state: z.enum(["VERIFIED", "UNKNOWN", "RELEASE_GATED"]),
        reasonCode: z.enum([
            "CLAIMED_ENTITLEMENT_CURRENT",
            "ENTITLEMENT_UNAVAILABLE",
            "ENTITLEMENT_IDENTITY_MISMATCH",
            "ENTITLEMENT_NOT_CLAIMED",
            "BOOK_BINDING_NOT_CURRENT",
        ]),
        quantity: z.number().int().nonnegative().nullable(),
        purchaseChannel: z.enum(["QVC", "DIRECT"]).nullable(),
        test: z.boolean().nullable(),
    })
        .strict(),
    offer: z
        .object({
        state: z.enum(["VERIFIED_CURRENT_RECORD", "UNKNOWN", "RELEASE_GATED"]),
        reasonCode: z.enum([
            "ACTIVE_BOUND_OFFER",
            "OFFER_UNAVAILABLE",
            "DIRECT_ENTITLEMENT_HAS_NO_OFFER",
            "OFFER_IDENTITY_MISMATCH",
            "OFFER_NOT_ACTIVE",
            "ENTITLEMENT_UNAVAILABLE",
            "BOOK_BINDING_NOT_CURRENT",
        ]),
        unitPriceCents: z.number().int().positive().nullable(),
        currency: z.literal("USD").nullable(),
        channel: z.enum(["QVC", "HSN", "DIRECT", "INTERNAL_FIXTURE"]).nullable(),
        test: z.boolean().nullable(),
        priceAuthority: z.enum(["ORIGINAL_ENTITLEMENT_OFFER_ONLY", "UNAVAILABLE"]),
    })
        .strict(),
    extraCopy: z
        .object({
        state: z.literal("RELEASE_GATED"),
        reasonCode: z.literal("EXTRA_COPY_PRICE_AND_REFUND_POLICY_UNAVAILABLE"),
    })
        .strict(),
    truthBoundary: z.literal("FACTS_DO_NOT_GRANT_APPROVAL_PRINT_PERMISSION_CHECKOUT_PRICE_OR_PROVIDER_AUTHORITY"),
})
    .strict();
//# sourceMappingURL=book-product-facts.js.map